import styled from '@emotion/styled';

const Title = styled.h2`
  margin: 0 0 8px;
  font-size: 1rem;
  color: #424242;
`;

export default Title;
